import { userConstants } from "../constants/userConstants";

const initialState = {
  sending: false,
  userResponse: {},
  error: {},
  loading: false,
  forgotResponse: {},
  tokenDetail: {},
  resetResponse: {}
};

function userGet(state) {
  return { ...state, isFetching: true, error: null, user: [] };
}
function userGetSuccess(state, action) {
  const { user } = action.user;
  return { ...state, isFetching: false, error: null, ...user };
}

function userGetError(state, action) {
  const { error } = action;
  return { ...state, isFetching: false, error: error.message };
}

export default function usersReducer(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        sending: true
      };
    case userConstants.LOGIN_SUCCESS:
      return {
        ...state,
        userResponse: action.user
      };
    case userConstants.LOGIN_FAILURE:
      return {
        error: action.error
      };
    case userConstants.LOGOUT:
      return {};
    case userConstants.GETALL_REQUEST:
      return {
        loading: true
      };
    case userConstants.GETALL_SUCCESS:
      return {
        items: action.users
      };
    case userConstants.GETALL_FAILURE:
      return {
        error: action.error
      };
    case userConstants.FORGOTPWD_REQUEST:
      return {
        loading: true
      };
    case userConstants.FORGOTPWD_SUCCESS:
      return {
        ...state,
        forgotResponse: action.data
      };
    case userConstants.FORGOTPWD_FAILURE:
      return {
        error: action.error
      };
    case userConstants.GET_USERLOGIN_BYTOKEN_REQUEST:
      return {
        loading: true
      };
    case userConstants.GET_USERLOGIN_BYTOKEN_SUCCESS:
      return {
        tokenDetail: action.data
      };
    case userConstants.GET_USERLOGIN_BYTOKEN_FAILURE:
      return {
        error: action.error
      };
    case userConstants.ResetPasssword_REQUEST:
      return {
        loading: true
      };
    case userConstants.ResetPasssword_SUCCESS:
      return {
        ...state,
        resetResponse: action.data
      };
    case userConstants.ResetPasssword_FAILURE:
      return {
        error: action.error
      };

    case userConstants.DELETE_REQUEST:
      return {
        ...state,
        items: state.items.map(
          user => (user.id === action.id ? { ...user, deleting: true } : user)
        )
      };
    case userConstants.GET_USER_REQUEST:
      return userGet(state);
    case userConstants.GET_USER_SUCCESS:
      return userGetSuccess(state, action);
    case userConstants.GET_USER_FAILURE:
      return userGetError(state, action);
    case userConstants.DELETE_SUCCESS:
      // remove deleted user from state
      return {
        items: state.items.filter(user => user.id !== action.id)
      };
    case userConstants.DELETE_FAILURE:
      // remove 'deleting:true' property and add 'deleteError:[error]' property to user
      return {
        ...state,
        items: state.items.map(user => {
          if (user.id === action.id) {
            // make copy of user without 'deleting:true' property
            const { deleting, ...userCopy } = user;
            // return copy of user with 'deleteError:[error]' property
            return { ...userCopy, deleteError: action.error };
          }

          return user;
        })
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/user.js